var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.614,
    height: 48.916,
    viewBox: "0 0 37.614 48.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182757",
    "data-name": "\\uADF8\\uB8F9 182757",
    transform: "translate(0 48.916) rotate(-90)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182380",
    "data-name": "\\uADF8\\uB8F9 182380",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182378",
    "data-name": "\\uADF8\\uB8F9 182378",
    transform: "translate(0.355 0.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130796",
    "data-name": "\\uD328\\uC2A4 130796",
    d: "M281.484,235.529s-28.835-15.615-28.847-15.627a9.288,9.288,0,0,0-9.158.226c-4.81,2.859-7.17,9.531-4.346,14.4,1.638,2.829,3.386,3.6,5.135,4.62l28.421,15.75Z",
    transform: "translate(-237.918 -218.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182379",
    "data-name": "\\uADF8\\uB8F9 182379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130797",
    "data-name": "\\uD328\\uC2A4 130797",
    d: "M272.631,255.172l-28.768-15.942c-.194-.113-.381-.22-.567-.326a10.863,10.863,0,0,1-4.707-4.43c-2.81-4.851-.718-11.814,4.475-14.9a9.588,9.588,0,0,1,9.518-.234l.048.026c1.233.673,28.518,15.449,28.8,15.6l.3.162ZM248.048,218.92a9.018,9.018,0,0,0-4.609,1.281c-4.863,2.89-6.833,9.389-4.216,13.906a10.121,10.121,0,0,0,4.436,4.161c.189.108.377.216.567.326l28.067,15.554,8.49-18.7c-24.7-13.378-28.056-15.193-28.543-15.471l0,.007A8.816,8.816,0,0,0,248.048,218.92Z",
    transform: "translate(-237.335 -218.188)",
    fill: "#111"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182383",
    "data-name": "\\uADF8\\uB8F9 182383",
    transform: "translate(3.01 2.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182381",
    "data-name": "\\uADF8\\uB8F9 182381",
    transform: "translate(0.361 0.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130798",
    "data-name": "\\uD328\\uC2A4 130798",
    d: "M247.694,238.446c-.189-.11-.377-.218-.566-.325a7.545,7.545,0,0,1-3.457-3.189c-1.884-3.255-.321-8.168,3.28-10.309a6.39,6.39,0,0,1,3.286-.934,5.916,5.916,0,0,1,2.8.708l26.486,14.354-6.275,13.924Z",
    transform: "translate(-242.867 -223.689)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182382",
    "data-name": "\\uADF8\\uB8F9 182382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130799",
    "data-name": "\\uD328\\uC2A4 130799",
    d: "M273.018,252.805a.366.366,0,0,1-.179-.046L247.284,238.53l-.007,0-.55-.316a7.947,7.947,0,0,1-3.6-3.33c-1.979-3.417-.354-8.568,3.409-10.806a6.735,6.735,0,0,1,3.473-.986,6.288,6.288,0,0,1,2.976.753l26.486,14.354a.366.366,0,0,1,.158.472L273.35,252.59a.364.364,0,0,1-.332.215Zm-25.377-14.913,25.206,14.034,5.972-13.251-26.187-14.192a5.557,5.557,0,0,0-2.627-.664,6.012,6.012,0,0,0-3.1.883c-3.439,2.044-4.94,6.72-3.15,9.811a7.166,7.166,0,0,0,3.322,3.055Z",
    transform: "translate(-242.275 -223.088)",
    fill: "#111"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182386",
    "data-name": "\\uADF8\\uB8F9 182386",
    transform: "translate(3.01 2.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182384",
    "data-name": "\\uADF8\\uB8F9 182384",
    transform: "translate(0.361 0.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130800",
    "data-name": "\\uD328\\uC2A4 130800",
    d: "M247.128,238.121a7.545,7.545,0,0,1-3.457-3.189c-1.884-3.255-.321-8.168,3.28-10.309a6.39,6.39,0,0,1,3.286-.934,5.916,5.916,0,0,1,2.8.708l6.083,3.314-7.441,12.861S247.317,238.228,247.128,238.121Z",
    transform: "translate(-242.867 -223.689)",
    fill: "#00ddb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182385",
    "data-name": "\\uADF8\\uB8F9 182385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130801",
    "data-name": "\\uD328\\uC2A4 130801",
    d: "M251.448,240.7a.368.368,0,0,1-.173-.043c-.177-.1-4.369-2.348-4.56-2.456a7.929,7.929,0,0,1-3.592-3.324c-1.979-3.417-.354-8.568,3.409-10.806a6.735,6.735,0,0,1,3.473-.986,6.288,6.288,0,0,1,2.976.753l6.084,3.314a.369.369,0,0,1,.177.222.364.364,0,0,1-.036.282l-7.442,12.862A.365.365,0,0,1,251.448,240.7Zm-1.442-16.883a6.012,6.012,0,0,0-3.1.883c-3.439,2.044-4.94,6.72-3.15,9.811a7.166,7.166,0,0,0,3.322,3.055h0c.136.078,2.67,1.44,4.231,2.279l7.076-12.23-5.753-3.134A5.557,5.557,0,0,0,250.005,223.82Z",
    transform: "translate(-242.275 -223.088)",
    fill: "#111"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182389",
    "data-name": "\\uADF8\\uB8F9 182389",
    transform: "translate(30.636 16.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182387",
    "data-name": "\\uADF8\\uB8F9 182387",
    transform: "translate(0.365 0.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130802",
    "data-name": "\\uD328\\uC2A4 130802",
    d: "M298.56,265.417a7.954,7.954,0,0,1-1.015.371,6.862,6.862,0,0,1-6.453-1.219,7.2,7.2,0,0,1-1.8-2.264,9.529,9.529,0,0,1-1.062-3.979c-.3-5.517,3.364-11.114,8.195-12.505a6.884,6.884,0,0,1,6.3,1.1s.009.009.009.009a8.491,8.491,0,0,1,3.007,6.355C306.025,258.408,302.877,263.6,298.56,265.417Z",
    transform: "translate(-288.209 -245.505)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182388",
    "data-name": "\\uADF8\\uB8F9 182388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130803",
    "data-name": "\\uD328\\uC2A4 130803",
    d: "M295.127,266.237a6.949,6.949,0,0,1-4.5-1.623,7.593,7.593,0,0,1-1.9-2.377,9.815,9.815,0,0,1-1.1-4.127c-.312-5.668,3.482-11.445,8.458-12.878a7.237,7.237,0,0,1,6.576,1.119l.1.03.034.077a8.848,8.848,0,0,1,3.076,6.565c.291,5.224-2.892,10.593-7.4,12.491a8.416,8.416,0,0,1-3.345.721Zm3.238-20.6a7.538,7.538,0,0,0-2.076.3c-4.667,1.344-8.225,6.788-7.931,12.134a9.1,9.1,0,0,0,1.019,3.826,6.855,6.855,0,0,0,1.715,2.154,6.48,6.48,0,0,0,6.119,1.149,7.488,7.488,0,0,0,.968-.353l.006,0c4.239-1.784,7.229-6.847,6.957-11.778a8.107,8.107,0,0,0-2.868-6.087l-.076-.061A6.226,6.226,0,0,0,298.364,245.635Z",
    transform: "translate(-287.611 -244.903)",
    fill: "#111"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182392",
    "data-name": "\\uADF8\\uB8F9 182392",
    transform: "translate(33.369 19.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182390",
    "data-name": "\\uADF8\\uB8F9 182390",
    transform: "translate(0.365 0.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130804",
    "data-name": "\\uD328\\uC2A4 130804",
    d: "M299.688,264.539a5.315,5.315,0,0,1-.7.28,4.437,4.437,0,0,1-4.406-.791,4.873,4.873,0,0,1-1.207-1.606,6.941,6.941,0,0,1-.675-2.852c-.135-3.97,2.454-8.051,5.785-9.118a4.457,4.457,0,0,1,4.306.706.016.016,0,0,1,0,.007,5.983,5.983,0,0,1,1.977,4.537C304.9,259.391,302.671,263.173,299.688,264.539Z",
    transform: "translate(-292.694 -250.195)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182391",
    "data-name": "\\uADF8\\uB8F9 182391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130805",
    "data-name": "\\uD328\\uC2A4 130805",
    d: "M297.159,265.211a4.584,4.584,0,0,1-3.052-1.143,5.263,5.263,0,0,1-1.3-1.724,7.254,7.254,0,0,1-.71-3c-.14-4.116,2.569-8.368,6.039-9.479a4.8,4.8,0,0,1,4.609.739l.088.039.026.055a6.366,6.366,0,0,1,2.042,4.751c.13,3.791-2.146,7.737-5.294,9.181a5.71,5.71,0,0,1-.744.3A5.571,5.571,0,0,1,297.159,265.211Zm2.678-14.887a4.836,4.836,0,0,0-1.475.241c-3.179,1.018-5.661,4.946-5.532,8.757a6.637,6.637,0,0,0,.637,2.7,4.51,4.51,0,0,0,1.118,1.492,4.07,4.07,0,0,0,4.056.72,5.012,5.012,0,0,0,.654-.261l.007,0c2.9-1.327,4.991-4.977,4.871-8.493a5.617,5.617,0,0,0-1.843-4.266l-.071-.058A3.859,3.859,0,0,0,299.837,250.324Z",
    transform: "translate(-292.095 -249.591)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182394",
    "data-name": "\\uADF8\\uB8F9 182394",
    transform: "translate(40.351 24.509)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182393",
    "data-name": "\\uADF8\\uB8F9 182393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130806",
    "data-name": "\\uD328\\uC2A4 130806",
    d: "M304.87,258.408l6.888.969a18.307,18.307,0,0,1-1.618,6.03l-6.587-.741Z",
    transform: "translate(-303.553 -258.408)",
    fill: "#32303c"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182397",
    "data-name": "\\uADF8\\uB8F9 182397",
    transform: "translate(37.522 23.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182395",
    "data-name": "\\uADF8\\uB8F9 182395",
    transform: "translate(0.36 0.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130807",
    "data-name": "\\uD328\\uC2A4 130807",
    d: "M306.352,259.682s-2.382-1.188-2.386-1.191a2.781,2.781,0,0,0-2.767.088,3.376,3.376,0,0,0-1.328,4.4,3.477,3.477,0,0,0,1.57,1.412l2.244,1.159Z",
    transform: "translate(-299.5 -258.165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182396",
    "data-name": "\\uADF8\\uB8F9 182396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130808",
    "data-name": "\\uD328\\uC2A4 130808",
    d: "M303.628,265.819l-2.771-1.441a3.577,3.577,0,0,1-1.532-1.447,3.744,3.744,0,0,1,1.457-4.9,3.152,3.152,0,0,1,3.125-.1c.11.057,2.377,1.187,2.377,1.187l.315.157Zm-1.182-7.521a2.525,2.525,0,0,0-1.289.361,2.994,2.994,0,0,0-1.2,3.9,2.844,2.844,0,0,0,1.261,1.179l.176.1,1.885.973,2.363-5.2c-1.509-.753-1.94-.968-2.079-1.043v0A2.354,2.354,0,0,0,302.446,258.3Z",
    transform: "translate(-298.909 -257.566)",
    fill: "#111"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182400",
    "data-name": "\\uADF8\\uB8F9 182400",
    transform: "translate(40.433 25.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182398",
    "data-name": "\\uADF8\\uB8F9 182398",
    transform: "translate(0.366 0.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130809",
    "data-name": "\\uD328\\uC2A4 130809",
    d: "M307.45,266.385a2.379,2.379,0,0,1-.31.113,2.1,2.1,0,0,1-1.973-.373,2.2,2.2,0,0,1-.551-.691,2.906,2.906,0,0,1-.324-1.216,3.845,3.845,0,0,1,2.5-3.822,2.1,2.1,0,0,1,1.926.336l0,0a2.59,2.59,0,0,1,.918,1.942A3.906,3.906,0,0,1,307.45,266.385Z",
    transform: "translate(-304.287 -260.3)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182399",
    "data-name": "\\uADF8\\uB8F9 182399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130810",
    "data-name": "\\uD328\\uC2A4 130810",
    d: "M306.247,266.725a2.392,2.392,0,0,1-1.547-.553,2.535,2.535,0,0,1-.643-.8,3.235,3.235,0,0,1-.366-1.364,4.234,4.234,0,0,1,2.769-4.194,2.453,2.453,0,0,1,2.252.4h0l.016.013a2.953,2.953,0,0,1,1.046,2.2,4.287,4.287,0,0,1-2.414,4.065,2.844,2.844,0,0,1-.355.129A2.727,2.727,0,0,1,306.247,266.725Zm.978-6.294a2.047,2.047,0,0,0-.563.082,3.472,3.472,0,0,0-2.24,3.451,2.555,2.555,0,0,0,.282,1.062,1.84,1.84,0,0,0,.461.583,1.732,1.732,0,0,0,1.638.3,1.863,1.863,0,0,0,.263-.1l.007,0a3.522,3.522,0,0,0,1.971-3.351,2.225,2.225,0,0,0-.779-1.675l-.017-.014A1.653,1.653,0,0,0,307.225,260.431Z",
    transform: "translate(-303.686 -259.698)",
    fill: "#111"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182403",
    "data-name": "\\uADF8\\uB8F9 182403",
    transform: "translate(9.428 6.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182401",
    "data-name": "\\uADF8\\uB8F9 182401",
    transform: "translate(0.366 0.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130811",
    "data-name": "\\uD328\\uC2A4 130811",
    d: "M260.277,242.758a5.382,5.382,0,0,1-.7.234,4.627,4.627,0,0,1-4.356-.947,4.865,4.865,0,0,1-1.178-1.578,6.516,6.516,0,0,1-.638-2.736c-.09-3.774,2.518-7.531,5.829-8.395a4.645,4.645,0,0,1,4.257.862s0,.006,0,.006a5.784,5.784,0,0,1,1.909,4.394A8.8,8.8,0,0,1,260.277,242.758Z",
    transform: "translate(-253.406 -229.157)",
    fill: "#044742"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182402",
    "data-name": "\\uADF8\\uB8F9 182402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130812",
    "data-name": "\\uD328\\uC2A4 130812",
    d: "M257.981,243.3a4.8,4.8,0,0,1-3.234-1.221,5.264,5.264,0,0,1-1.265-1.694,6.821,6.821,0,0,1-.673-2.885c-.093-3.927,2.643-7.855,6.1-8.758a5,5,0,0,1,4.53.89l.108.036.029.082a6.156,6.156,0,0,1,1.962,4.6,9.164,9.164,0,0,1-5.36,8.508,5.846,5.846,0,0,1-.741.249A5.75,5.75,0,0,1,257.981,243.3Zm2.377-14.017a5.021,5.021,0,0,0-1.263.167c-3.149.821-5.64,4.425-5.554,8.032a6.189,6.189,0,0,0,.6,2.583,4.534,4.534,0,0,0,1.091,1.466,4.259,4.259,0,0,0,4.022.868,4.957,4.957,0,0,0,.65-.219l.006,0a8.4,8.4,0,0,0,4.9-7.811,5.41,5.41,0,0,0-1.778-4.122l-.08-.068A4.091,4.091,0,0,0,260.357,229.286Z",
    transform: "translate(-252.806 -228.554)",
    fill: "#111"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182405",
    "data-name": "\\uADF8\\uB8F9 182405",
    transform: "translate(5.604 3.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182404",
    "data-name": "\\uADF8\\uB8F9 182404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130813",
    "data-name": "\\uD328\\uC2A4 130813",
    d: "M246.856,237.236c-2.113-10.316,6.765-13.463,6.855-13.494l.236.692c-.341.117-8.356,2.981-6.374,12.654Z",
    transform: "translate(-246.531 -223.742)",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationBattery);
export default __webpack_public_path__ + "static/media/information_battery.abf8162005bc26355364d5bc754d72e7.svg";
export { ForwardRef as ReactComponent };